module.exports = __webpack_public_path__ + "img/table-picnic.856de02c.svg";